import { UseCaseId } from '../models/constraint.model';

const useCaseOptions: { value: UseCaseId; label: string }[] = [
  { value: 'UC.digitalization.sc', label: 'policy.useCase.UC.digitalization.sc' },
  { value: 'UC.shortage.sc', label: 'policy.useCase.UC.shortage.sc' },
  { value: 'UC.pcf', label: 'policy.useCase.UC.pcf' }
];

export { useCaseOptions };
